import { Injectable } from '@angular/core';
import { NavigationItem } from './navigation-item.interface';
import { BehaviorSubject, Observable } from 'rxjs';
import {AuthService} from "../../shared/services/auth.service";
import {StorageService} from "../../shared/services/storage.service";
import {SocketService} from "../../shared/services/socket.service";

@Injectable({
  providedIn: 'root'
})
export class NavigationLoaderService {
  user: any;
  private readonly _items: BehaviorSubject<NavigationItem[]> =
    new BehaviorSubject<NavigationItem[]>([]);

  get items$(): Observable<NavigationItem[]> {
    return this._items.asObservable();
  }

  constructor(private socketService: SocketService,private authService: AuthService) {
    this.getSelfDetails();
  }

  getSelfDetails() {
    let self = StorageService.getItem('self');
    if (self) {
      this.authService.self().subscribe((data: any) => {
        if (data && data.id) {
          this.user = data;
          /*this.socketService.onConnect().subscribe(() => {
            this.socketService.joinGroup(data?.id, data?.user_type);
          });

          this.socketService.onDisconnect().subscribe(() => {
            console.log('Socket connection lost: Disconnected from the server');
          });*/
          this.loadNavigation();
          /*if (!sessionStorage.getItem('reloaded')) {
            sessionStorage.setItem('reloaded', 'true');
            location.reload();
          } else {
            sessionStorage.removeItem('reloaded');
            this.loadNavigation();
          }*/
          /*if (this.user && this.user['user_type'] === 'EMPLOYEE') {
            this.checkUserDetails();
          } else {
            // this.visibleAllMenu();
            //this.loadNavigation();
            if (!window.location.search.includes('reloaded=true')) {
              window.location.href = window.location.pathname + '?reloaded=true';
            } else {
              this.loadNavigation();
            }
          }*/
        }
      });
    }
  }

  loadNavigation(): void {
    if (this.user && this.user['center_type'] === 'PRO') {
      this._items.next([
        {
          type: 'subheading',
          label: 'Dashboard',
          availableTo: ['CENTER', 'CENTER_BRANCH'],
          children: [
            {
              type: 'link',
              label: 'Home',
              route: '/home',
              icon: 'mat:dashboard',
              routerLinkActiveOptions: { exact: true },
              availableTo: ['CENTER', 'CENTER_BRANCH']
            }
          ]
        },
        {
          type: 'subheading',
          label: 'Students',
          availableTo: ['CENTER', 'CENTER_BRANCH'],
          children: [
            {
              type: 'link',
              label: 'Add Students',
              route: '/students/add-student',
              icon: 'mat:person_add',
              availableTo: ['CENTER', 'CENTER_BRANCH']
            },
            {
              type: 'link',
              label: 'List Students',
              route: '/students/list-students',
              icon: 'mat:diversity_3',
              availableTo: ['CENTER', 'CENTER_BRANCH']
            }
          ]
        }
      ]);
    } else {
      this._items.next([
        {
          type: 'subheading',
          label: 'Dashboard',
          availableTo: ['CENTER', 'CENTER_BRANCH'],
          children: [
            {
              type: 'link',
              label: 'Home',
              route: '/home',
              icon: 'mat:dashboard',
              routerLinkActiveOptions: { exact: true },
              availableTo: ['CENTER', 'CENTER_BRANCH']
            }
          ]
        },
        {
          type: 'subheading',
          label: 'General',
          availableTo: ['CENTER'],
          children: [
            {
              type: 'dropdown',
              label: 'Branches',
              icon: 'mat:admin_panel_settings',
              availableTo: ['CENTER'],
              children: [
                {
                  type: 'link',
                  label: 'Add',
                  route: '/general/branches/add',
                  availableTo: ['CENTER']
                },
                {
                  type: 'link',
                  label: 'List',
                  route: '/general/branches/list',
                  availableTo: ['CENTER']
                }
              ]
            }
          ]
        },
        {
          type: 'subheading',
          label: 'Phases',
          availableTo: ['CENTER', 'CENTER_BRANCH'],
          children: [
            {
              type: 'link',
              label: 'Stages',
              route: '/phases/stages',
              icon: 'mat:settings_overscan',
              availableTo: ['CENTER', 'CENTER_BRANCH']
            }
          ]
        },
        {
          type: 'subheading',
          label: 'Leads',
          availableTo: ['CENTER', 'CENTER_BRANCH'],
          children: [
            {
              type: 'link',
              label: 'Manual',
              route: '/leads/manual',
              icon: 'mat:ballot',
              availableTo: ['CENTER', 'CENTER_BRANCH']
            },
            {
              type: 'link',
              label: 'Facebook',
              route: '/leads/facebook',
              icon: 'mat:thumb_up',
              availableTo: ['CENTER', 'CENTER_BRANCH']
            },
            {
              type: 'link',
              label: 'Messenger',
              route: '/leads/messenger',
              icon: 'mat:chrome_reader_mode',
              availableTo: ['CENTER', 'CENTER_BRANCH']
            },
            {
              type: 'link',
              label: 'Instagram',
              route: '/leads/instagram',
              icon: 'mat:add_a_photo',
              availableTo: ['CENTER', 'CENTER_BRANCH']
            }
          ]
        },
        {
          type: 'subheading',
          label: 'Students',
          availableTo: ['CENTER', 'CENTER_BRANCH'],
          children: [
            {
              type: 'link',
              label: 'Add Students',
              route: '/students/add-student',
              icon: 'mat:person_add',
              availableTo: ['CENTER', 'CENTER_BRANCH']
            },
            {
              type: 'link',
              label: 'List Students',
              route: '/students/list-students',
              icon: 'mat:diversity_3',
              availableTo: ['CENTER', 'CENTER_BRANCH']
            },
            {
              type: 'link',
              label: 'Process Students',
              route: '/students/process-student',
              icon: 'mat:contact_emergency',
              availableTo: ['CENTER', 'CENTER_BRANCH']
            },
            {
              type: 'link',
              label: 'Process Bran. Students',
              route: '/students/process-branch-student',
              icon: 'mat:contact_emergency',
              availableTo: ['CENTER']
            },
            {
              type: 'link',
              label: 'Report',
              route: '/students/report',
              icon: 'mat:dashboard_customize',
              availableTo: ['CENTER', 'CENTER_BRANCH']
            }
          ]
        },
        {
          type: 'subheading',
          label: 'Accounts',
          availableTo: ['CENTER', 'CENTER_BRANCH'],
          children: [
            {
              type: 'link',
              label: 'Process Transaction',
              route: '/accounts/process-transactions',
              icon: 'mat:add_card',
              availableTo: ['CENTER', 'CENTER_BRANCH']
            },
            // {
            //   type: 'link',
            //   label: 'Instalment Transaction',
            //   route: '/accounts/instalment-transactions',
            //   icon: 'mat:card_membership',
            //   availableTo: ['CENTER', 'CENTER_BRANCH']
            // },
            {
              type: 'link',
              label: 'Receipt Transaction',
              route: '/accounts/receipt-process-transactions',
              icon: 'mat:credit_card',
              availableTo: ['CENTER', 'CENTER_BRANCH']
            },
            {
              type: 'link',
              label: 'Wallet Transaction',
              route: '/accounts/wallet-transactions',
              icon: 'mat:account_balance_wallet',
              availableTo: ['CENTER', 'CENTER_BRANCH']
            },
            {
              type: 'link',
              label: 'Liability',
              route: '/accounts/liability',
              icon: 'mat:supervisor_account',
              availableTo: ['CENTER', 'CENTER_BRANCH']
            },
            {
              type: 'link',
              label: 'Branch Liability',
              route: '/accounts/branch-liability',
              icon: 'mat:supervisor_account',
              availableTo: ['CENTER']
            },
            {
              type: 'link',
              label: 'Report',
              route: '/accounts/report',
              icon: 'mat:dashboard_customize',
              availableTo: ['CENTER', 'CENTER_BRANCH']
            }
          ]
        },
        {
          type: 'subheading',
          label: 'Receipts',
          availableTo: ['CENTER', 'CENTER_BRANCH'],
          children: [
            {
              type: 'link',
              label: 'Add',
              route: '/receipt/add',
              icon: 'mat:post_add',
              availableTo: ['CENTER', 'CENTER_BRANCH']
            },
            {
              type: 'link',
              label: 'List',
              route: '/receipt/list',
              icon: 'mat:format_align_left',
              availableTo: ['CENTER', 'CENTER_BRANCH']
            },
            {
              type: 'link',
              label: "Branch' Receipt",
              route: '/receipt/branch',
              icon: 'mat:receipt',
              availableTo: ['CENTER']
            },
            {
              type: 'link',
              label: 'Report',
              route: '/receipt/report',
              icon: 'mat:dashboard_customize',
              availableTo: ['CENTER', 'CENTER_BRANCH']
            }
          ]
        },
        {
          type: 'subheading',
          label: 'Tickets',
          availableTo: ['CENTER', 'CENTER_BRANCH'],
          children: [
            {
              type: 'link',
              label: 'Admission',
              route: '/tickets/admission',
              icon: 'mat:contact_mail',
              availableTo: ['CENTER', 'CENTER_BRANCH']
            },
            {
              type: 'link',
              label: 'Leads',
              route: '/tickets/leads',
              icon: 'mat:contact_phone',
              availableTo: ['CENTER', 'CENTER_BRANCH']
            },
            {
              type: 'link',
              label: 'Others',
              route: '/tickets/other',
              icon: 'mat:local_library',
              availableTo: ['CENTER', 'CENTER_BRANCH']
            },
            {
              type: 'link',
              label: 'Report',
              route: '/tickets/report',
              icon: 'mat:dashboard_customize',
              availableTo: ['CENTER', 'CENTER_BRANCH']
            }
          ]
        },
        {
          type: 'subheading',
          label: 'Notifications',
          availableTo: ['CENTER', 'CENTER_BRANCH'],
          children: [
            {
              type: 'link',
              label: 'List',
              route: '/notification/list',
              icon: 'mat:notifications',
              availableTo: ['CENTER', 'CENTER_BRANCH']
            },
            {
              type: 'link',
              label: 'Report',
              route: '/notification/report',
              icon: 'mat:dashboard_customize',
              availableTo: ['CENTER']
            }
          ]
        }
      ]);
    }
  }
}
